import React from 'react';

import { margin } from '@lumapps/classnames';
import { mdiAccountGroup } from '@lumapps/lumx/icons';
import { FlexBox, Size } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';
import { UserList } from '@lumapps/user-ui/components/UserList';

import { useSpaceMembers } from '../../../hooks/useSpaceMembers';
import { SPACE_KEYS } from '../../../keys';
import { SpaceRole } from '../../../types';

export const Members = () => {
    const { users, isLoading, onLoadMore, onSearch, searchQuery } = useSpaceMembers({
        role: SpaceRole.member,
    });

    const { translateKey } = useTranslate();

    return (
        <FlexBox orientation="vertical">
            <UserList
                users={users}
                isLoading={isLoading}
                onLoadMore={onLoadMore}
                hasLoadMoreButton
                hasMore={Boolean(onLoadMore)}
                onSearch={onSearch}
                onSearchClear={() => onSearch('')}
                searchText={searchQuery}
                scope="space-about-members"
                emptyStateProps={{
                    message: translateKey(SPACE_KEYS.NO_MEMBERS),
                    iconProps: { icon: mdiAccountGroup, size: Size.m },
                    wrapperProps: { className: margin('top', 'big') },
                }}
            />
        </FlexBox>
    );
};
